'use strict';

var React = require('react');
var index = require('../../Menu/index.js');
require('../../Typography/src/Heading.js');
require('../../Typography/src/Link.js');
require('../../Typography/src/ListItem.js');
require('../../Typography/src/OrderedList.js');
var Text = require('../../Typography/src/Text.js');
require('../../Typography/src/UnorderedList.js');

const defaultNotFoundText = 'К сожалению, по вашим параметрам ничего не найдено, попробуйте изменить их';
const EmptyContent = (props) => {
    const { emptyContent, ...rest } = props;
    return (React.createElement(index.Menu, { ...rest }, emptyContent || (React.createElement(index.Menu.Item, { disabled: true },
        React.createElement(Text.Text, { className: "h-text-center h-color-D60" }, defaultNotFoundText)))));
};

exports.EmptyContent = EmptyContent;
exports.defaultNotFoundText = defaultNotFoundText;
//# sourceMappingURL=EmptyContent.js.map
